import { makeStyles } from '@material-ui/core/styles';

export const tooltipStyles = makeStyles(theme => ({
    NotificationTipContainer: {
        display: 'flex',
        alignItems: 'center'
    }
}));
